import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import { useState } from 'react'
import Fields from '@components/fields'
import { Form, Formik } from 'formik'
import DoctorProfileDetails from '@commons/userDetails/doctorPersonalDetails/profileDetails'
import Documents from '@commons/userDetails/documents'
import Button from '@components/button'
import { AuthSchema } from '@validations'
import { User } from '@apis'
import { Helper } from '@utils'
import { useNavigate } from 'react-router-dom'
import PasswordCard from '@commons/userDetails/password'
const AdminDoctorFormPage = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [initialValues] = useState({
    name: '',
    email: '',
    phoneNo: '',
    countryCode: 977,
    address: '',
    departments: '',
    qualification: '',
    gender: '',
    yos: '',
    appointmentType: '',
    avatar: '',
    coverImage: '',
    specializations: [],
    fees: 0,
    age: '',
    identifications: [
      {
        image: '',
        name: 'Citizenship',
        number: '',
      },
      {
        image: '',
        name: 'Passport',
        number: '',
      },
      {
        image: '',
        name: 'National Id',
        number: '',
      },
    ],
    licenses: [],
    signature: '',
    password: '',
  })
  const submitHandler = async (values: any) => {
    const payload: any = {
      name: values?.name,
      phoneNo: values?.phoneNo,
      countryCode: values?.countryCode,
      password: values?.password || Helper.generateRandomPassword(),
      email: values?.email,
      infos: {
        gender: values?.gender,
        fees: values?.fees || 0,
        qualification: values?.qualification,
        yos: values?.yos,
        age: values?.age,
        address: values?.address,
        appointmentType: values?.appointmentType,
      },
      role: 'doctor',
    }
    const identifications = values?.identifications?.filter(
      (document) => !!document?.image?.base64 && !!document?.number,
    )

    if (!!identifications?.length) {
      payload.identifications = identifications?.map((document: any) => {
        return {
          ...document,
          image: {
            base64: document?.image?.base64,
            extension: document?.image?.extension,
          },
        }
      })
    }

    if (!!values?.licenses?.length) {
      payload.licenses = values?.licenses?.map((document: any) => {
        return {
          ...document,
          image: {
            base64: document?.image?.base64,
            extension: document?.image?.extension,
          },
        }
      })
    }

    if (!!values?.signature) {
      payload.signature = [
        {
          name: 'Signature',
          image: {
            base64: values?.signature?.base64,
            extension: values?.signature?.extension,
          },
        },
      ]
    }

    if (values?.avatar?.base64) {
      payload.avatar = {
        base64: values?.avatar?.base64,
        extension: values?.avatar?.extension,
      }
    }
    if (values?.coverImage?.base64) {
      payload.infos = {
        ...payload.infos,
        coverImage: {
          base64: values?.coverImage?.base64,
          extension: values?.coverImage?.extension,
        },
      }
    }
    if (!!values?.departments) {
      payload.departments = [values.departments]
    }
    if (!!values?.specializations?.length) {
      payload.specializations = values.specializations?.map(
        (specialization) => specialization.id,
      )
    }
    setLoading(true)
    await User.create({
      data: payload,
      action: 'prepend',
      state: 'activeDoctors',
    })
      .then(() => {
        navigate('/admin/doctors')
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Column rowGap={20}>
      <SectionHeading title="Adding Doctor" />
      <Column>
        <Formik
          initialValues={initialValues}
          onSubmit={submitHandler}
          validationSchema={AuthSchema.createValidationSchema.concat(
            AuthSchema.doctorStep2ValidationSchema,
          )}
        >
          {({ handleSubmit, setFieldValue, values, errors }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Column styleColumn="margin-bottom:60px;position:relative;">
                    <Fields.Upload
                      varient="banner"
                      name="coverImage"
                      size={250}
                    />
                    <Fields.Upload
                      varient="avatar"
                      name="avatar"
                      size={80}
                      styleWrapper="position:absolute;bottom:-40px;"
                    />
                  </Column>
                  <DoctorProfileDetails
                    setFieldValue={setFieldValue}
                    values={values}
                    errors={errors}
                  />

                  <Documents
                    identifications={values?.identifications}
                    licenses={values?.licenses}
                    setFieldValue={setFieldValue}
                    role="doctor"
                  />
                  <PasswordCard />

                  <Column alignItems="flex-end">
                    <Button
                      type="submit"
                      title="Save Profile"
                      height={45}
                      loading={loading}
                    />
                  </Column>
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Column>
    </Column>
  )
}

export default AdminDoctorFormPage
